import { useQuery } from '@tanstack/react-query'
import { classifySolutionId } from '@loop3/universe'
import { getSolution } from '@/lib/api/kb'

/** One solution by kb uuid or Notion page id; malformed ids never query. */
export function useSolution(id: string | undefined) {
  return useQuery({
    queryKey: ['kb', 'solution', id],
    queryFn: () => getSolution(id!),
    enabled: !!id && classifySolutionId(id) !== null,
    // The copy refreshes hourly; 60s keeps back-navigation instant.
    staleTime: 60_000,
  })
}
